
import { Container, Row } from "reactstrap";
import { Col } from "react-bootstrap";
import { Breadcrumbs } from '../../AbstractElements';
import SettingHome from "./SettingHome";
import React, { Fragment } from 'react';
import { useTranslation } from "react-i18next";

export default function SettingList() {
    const { t } = useTranslation();
    return (
        <Fragment>
            <Breadcrumbs mainTitle={t("Setting")} parent={t("Home")} title={t("Setting")} />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                        <SettingHome/>    
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}
